import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/productbonus`;

// CREATE =>  POST: add a new product to the server
export function createBonus(bonus) {
    return axios.post(API_URL, { ...bonus });
}

// READ
export function getAllBonus() {
    return axios.get(API_URL);
}

export function getPaginatedBonus(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getBonusById(bonusId) {
    return axios.get(`${API_URL}/${bonusId}`);
}



// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the bonus on the server
export function updateBonus(bonusId, bonus) {
    return axios.put(`${API_URL}/${bonusId}`, { ...bonus });
}


// DELETE => delete the product from the server
export function deleteBonus(bonusId) {
    return axios.delete(`${API_URL}/${bonusId}`);
}
